import layout from './DesignWizard.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DesignWizardViewModelType from '@/ViewModels/Controls/DesignWizardViewModel';
import LabelType from '@/Controls/Label';

export default class DesignWizard extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private label: LabelType;

    public constructor(private viewModel: DesignWizardViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl);
        this.widget(null);


        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'designwizard',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('DesignWizard', DesignWizard, 'RADPresentation.HTMLClient.DefaultViewExtensions');